export interface AppReturnLocation {
  hash?: string;
  origin: string;
  pathname: string;
  search?: string;
}

export interface StripeReturnUrlOptions {
  returnToOrigin: string;
}

export interface AppReturnUrlOptions extends StripeReturnUrlOptions {
  returnToUrl: string;
}

export interface MercadoPagoOAuthReturnOptions extends AppReturnUrlOptions {
  redirectUri: string;
}

const getBrowserLocation = (): AppReturnLocation => window.location;

export const getCurrentAppReturnToOrigin = (
  location: AppReturnLocation = getBrowserLocation(),
): string => location.origin;

export const getCurrentAppReturnToUrl = (
  location: AppReturnLocation = getBrowserLocation(),
): string =>
  `${location.origin}${location.pathname}${location.search || ''}${location.hash || ''}`;

export const buildStripeReturnUrlOptions = (
  location: AppReturnLocation = getBrowserLocation(),
): StripeReturnUrlOptions => ({
  returnToOrigin: getCurrentAppReturnToOrigin(location),
});

export const buildMercadoPagoOAuthReturnOptions = (
  location: AppReturnLocation = getBrowserLocation(),
): MercadoPagoOAuthReturnOptions => {
  const returnToOrigin = getCurrentAppReturnToOrigin(location);

  return {
    redirectUri: `${returnToOrigin}/integrations/mercadopago/callback`,
    returnToOrigin,
    returnToUrl: getCurrentAppReturnToUrl(location),
  };
};
